"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveUpdatesListener = exports.LiveUpdatesListenerHistory = void 0;
var app_1 = require("@capacitor/app");
var react_dependency_injection_1 = require("@meraki-internal/react-dependency-injection");
var react_1 = require("react");
var LiveUpdatesService_1 = require("./LiveUpdatesService");
var DelayLiveUpdateInstallService_1 = require("./DelayLiveUpdateInstallService");
var LiveUpdatesListenerHistory = /** @class */ (function () {
    function LiveUpdatesListenerHistory() {
        throw new Error('LiveUpdatesListenerHistory should be set via IOC');
    }
    return LiveUpdatesListenerHistory;
}());
exports.LiveUpdatesListenerHistory = LiveUpdatesListenerHistory;
// ensures new ionic live updates are installed in near-real-time
var LiveUpdatesListener = function () {
    var history = (0, react_dependency_injection_1.useInstance)(LiveUpdatesListenerHistory);
    var delayer = (0, react_dependency_injection_1.useInstance)(DelayLiveUpdateInstallService_1.DelayLiveUpdateInstallService);
    // const history = useInstance(HistoryViewModel);
    var service = (0, react_dependency_injection_1.useInstance)(LiveUpdatesService_1.LiveUpdatesService);
    (0, react_1.useEffect)(function () {
        // when user foregrounds the app, download update if available, or
        // if inactive for a long time, install downloaded update if available
        app_1.App.addListener('appStateChange', function (_a) {
            var isActive = _a.isActive;
            return __awaiter(void 0, void 0, void 0, function () {
                var canInstall;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!isActive) return [3 /*break*/, 1];
                            delayer.onBackground();
                            return [3 /*break*/, 5];
                        case 1:
                            canInstall = delayer.onForeground().canInstall;
                            if (!canInstall) return [3 /*break*/, 3];
                            return [4 /*yield*/, service.installOrDownloadUpdateIfAvailable()];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, service.downloadUpdateIfAvailable()];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        });
        // when user navigates, install downloaded update if available
        history.listen(function (location) { return __awaiter(void 0, void 0, void 0, function () {
            var canInstall;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // don't install during auth flow, or we'll lose the token!
                        // (note this relies on the placeholder route in AppRouter)
                        if (location.pathname.startsWith('/oauth')) {
                            return [2 /*return*/];
                        }
                        canInstall = delayer.onHashChange().canInstall;
                        if (!canInstall) return [3 /*break*/, 2];
                        return [4 /*yield*/, service.installOrDownloadUpdateIfAvailable()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, service.downloadUpdateIfAvailable()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    }, []);
    return null;
};
exports.LiveUpdatesListener = LiveUpdatesListener;
//# sourceMappingURL=LiveUpdatesListener.js.map